import { Button, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

/**
 * Manual-refresh control shared by the three revenue pages (Portfolio /
 * Site / Machine — task D1). The auto-refresh interval on the underlying
 * `useQuery` hooks (see `REVENUE_LIVE_QUERY_OPTS` in `api/revenue.ts`) tops
 * out at 60s; this button lets an operator pull the latest numbers
 * on-demand without waiting for the next tick. Mirrors the existing
 * header-refresh convention (`MachineDetailDialog`, `SiteControllerHeartbeatPanel`):
 * `RefreshIcon` swaps for a spinner and the button disables while a fetch
 * (initial or background) is in flight.
 */
export function RevenueRefreshButton({ isFetching, onRefresh }: {
  isFetching: boolean;
  onRefresh: () => void;
}) {
  return (
    <Button
      size="small"
      variant="outlined"
      disabled={isFetching}
      onClick={onRefresh}
      startIcon={isFetching ? <CircularProgress size={14} /> : <RefreshIcon fontSize="small" />}
    >
      Refresh
    </Button>
  );
}
